import { GoogleMap, useJsApiLoader, HeatmapLayer } from '@react-google-maps/api';
import { useTheme } from '@mui/material/styles';
import { RetailerHeaderModel } from '../../../../app/services/api/ofdClient';
import { CreditSummary } from '../../../../app/services/api/generated';

interface CreditsClaimsByMarketProps {
  credits: CreditSummary[];
  retailers: RetailerHeaderModel[];
}

const CreditsClaimsByMarket = ({ credits, retailers }: CreditsClaimsByMarketProps) => {
  const theme = useTheme();

  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: 'AIzaSyAn3FgyVwPfbulsKlqDwOWTpwg2ChYe-yk',
    libraries: ['visualization'],
  });

  // Match credits to retailers by retailer name and get lat/lng
  const heatmapData = credits
    .map(c => {
      const retailer = retailers.find(r => r.name === c.retailer);
      if (retailer?.latitude && retailer?.longitude) {
        return {
          location: { lat: retailer.latitude, lng: retailer.longitude },
          weight: c.value,
        };
      }
      return null;
    })
    .filter((h): h is { location: { lat: number; lng: number }; weight: number } => !!h);

  const mapContainerStyle = {
    width: '100%',
    height: '200px',
    color: theme.palette.text.primary,
    fontSize: theme.typography.textSM.fontSize,
  };

  const center = {
    lat: 39.8283,
    lng: -98.5795,
  };

  return (
    isLoaded ? (
      <GoogleMap
        mapContainerStyle={mapContainerStyle}
        center={center}
        zoom={4}
        options={{
          disableDefaultUI: true,
          streetViewControl: false,
          mapTypeControl: false,
          zoomControl: false,
          fullscreenControl: true,
        }}
      >
        <HeatmapLayer
          data={heatmapData.map((h) => ({
            location: new window.google.maps.LatLng(h.location.lat, h.location.lng),
            weight: h.weight,
          }))}
        />
      </GoogleMap>
    ) : null
  );
};

export default CreditsClaimsByMarket;